import React from 'react';
import { FaLinkedinIn, FaYoutube, FaGithub } from 'react-icons/fa';
import styles from './Footer.module.css';
import { useLanguage } from '../../context/LanguageContext';

const Footer: React.FC = () => {
  const { t } = useLanguage();
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.socials}>
          <a href="https://linkedin.com/in/nuricanakturk" target="_blank" rel="noopener noreferrer" className={styles.socialIcon} title="LinkedIn">
            <FaLinkedinIn />
          </a>
          <a href="https://github.com/nuricanakturk" target="_blank" rel="noopener noreferrer" className={styles.socialIcon} title="GitHub">
            <FaGithub />
          </a>
          <a href="https://youtube.com/@nuricanakturk" target="_blank" rel="noopener noreferrer" className={styles.socialIcon} title="YouTube">
            <FaYoutube />
          </a>
        </div>
        <span className={styles.copy}>
          © {new Date().getFullYear()} <span className={styles.accent}>Nuri Can Akturk</span>. {t.footer.rights}
        </span>
      </div>
    </footer>
  );
};

export default Footer;
